import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';

const Container = styled.div`
  grid-area: image;
  align-self: center;
  justify-self: center;
`;

const Image = styled.img`
  max-width: 100%;
`;

const IconLogo = styled(Icon)`
  font-size: 2.5rem;

  ${upTo('sm')`
    font-size: 2rem;
  `}
`;

export default ({ logo_type, logo }) => (
  <Container>
    {logo_type === 'credit_card' ? (
      <Image src={`/images/payment-icons/${logo}.png`} />
    ) : logo_type === 'bank_institution' ? (
      <Image src={logo} />
    ) : logo_type === 'bank_default' ? (
      <IconLogo name="university" />
    ) : logo_type === 'internal' ? (
      <IconLogo name="user-circle" />
    ) : null}
  </Container>
);
